/**
 * Curated panel routes for Sttok AI deep links.
 * Keep in sync with api-restful-node/src/constants/sttokAiPanelRoutes.js
 */

export const STTOK_LINK_PROTOCOL = 'sttok://';

export type AiPanelRoute = {
  routeId: string;
  pathTemplate: string;
  labelKey: string;
  entities?: string[];
  topics?: string[];
};

export const AI_PANEL_ROUTES: AiPanelRoute[] = [
  {
    routeId: 'society-dashboard',
    pathTemplate: '/sociedad/:societyId',
    labelKey: 'Society',
    entities: ['societies'],
  },
  {
    routeId: 'stockplans-society',
    pathTemplate: '/beneficiarios-planes/:societyId',
    labelKey: 'PlansList',
    entities: ['stockPlans'],
  },
  {
    routeId: 'beneficiary-list',
    pathTemplate: '/beneficiarios/:societyId',
    labelKey: 'BeneficiariesList',
    entities: ['beneficiaries'],
  },
  {
    routeId: 'beneficiary-cards',
    pathTemplate: '/beneficiarios-fichas/:societyId',
    labelKey: 'BeneficiariesCards',
  },
  {
    routeId: 'summary-plans',
    pathTemplate: '/resumen-planes/:societyId',
    labelKey: 'BeneficiariesSummary',
  },
  {
    routeId: 'employee-list',
    pathTemplate: '/empleados/:societyId',
    labelKey: 'Employees',
    entities: ['employees'],
  },
  {
    routeId: 'employees-plan-list',
    pathTemplate: '/empleados-planes/:societyId',
    labelKey: 'EmployeesPlans',
  },
  {
    routeId: 'partners-list',
    pathTemplate: '/socios/:societyId',
    labelKey: 'Partners',
    entities: ['partners', 'shares', 'notes', 'observations'],
  },
  {
    routeId: 'partners-book',
    pathTemplate: '/socios-libro/:societyId',
    labelKey: 'BookOfPartners',
    entities: ['sharesTitles'],
  },
  {
    routeId: 'holding-classes',
    pathTemplate: '/clases-participaciones/:societyId',
    labelKey: 'HoldingClasses',
    entities: ['holdingClasses'],
  },
  {
    routeId: 'partners-categories',
    pathTemplate: '/socios-categorias/:societyId',
    labelKey: 'PartnerCategories',
    entities: ['partnerCategories'],
  },
  {
    routeId: 'investors-list',
    pathTemplate: '/inversores/:societyId',
    labelKey: 'Investors',
    entities: ['investors'],
  },
  {
    routeId: 'transactions-society',
    pathTemplate: '/transacciones/:societyId',
    labelKey: 'Transactions',
    entities: ['operations', 'operationTransactions'],
  },
  {
    routeId: 'boards-list',
    pathTemplate: '/juntas/:societyId',
    labelKey: 'Boards',
    entities: ['boards', 'boardOrders', 'boardParticipants'],
  },
  {
    routeId: 'admin-organ',
    pathTemplate: '/organo-admin/:societyId',
    labelKey: 'AdminOrgan',
    entities: ['societyDirectors'],
  },
  {
    routeId: 'representatives',
    pathTemplate: '/apoderados/:societyId',
    labelKey: 'Representatives',
    entities: ['societyRepresentatives'],
  },
  {
    routeId: 'auditors',
    pathTemplate: '/auditores/:societyId',
    labelKey: 'Auditors',
    entities: ['societyAuditors'],
  },
  {
    routeId: 'councils',
    pathTemplate: '/consejos/:societyId',
    labelKey: 'Councils',
    entities: ['councils'],
  },
  {
    routeId: 'committees',
    pathTemplate: '/comites/:societyId',
    labelKey: 'Committees',
    entities: ['committees', 'committeeMembers'],
  },
  {
    routeId: 'documents-docs',
    pathTemplate: '/documentos/documentos/:societyId',
    labelKey: 'Documents',
    entities: ['documents', 'folders'],
  },
  {
    routeId: 'signatures-list',
    pathTemplate: '/firmas/:societyId',
    labelKey: 'Signatures',
    entities: ['envelopes'],
  },
  {
    routeId: 'drafts-society',
    pathTemplate: '/borradores/:societyId',
    labelKey: 'Drafts',
    entities: ['drafts'],
  },
  {
    routeId: 'com-society',
    pathTemplate: '/comunicaciones/:societyId/enviados',
    labelKey: 'Communications',
    entities: ['communications'],
  },
  {
    routeId: 'equity-market',
    pathTemplate: '/mercado-de-acciones/:societyId',
    labelKey: 'EquityMarket',
    entities: ['tradingOffers', 'tradingOperations'],
  },
  {
    routeId: 'tender-offers-list',
    pathTemplate: '/tender-offers/:societyId',
    labelKey: 'TenderOffers',
  },
  {
    routeId: 'realties',
    pathTemplate: '/inmuebles/:societyId',
    labelKey: 'Realties',
    entities: ['realties'],
  },
  {
    routeId: 'partners-representants',
    pathTemplate: '/socios-representantes/:societyId',
    labelKey: 'PartnerRepresentants',
    entities: ['partnerRepresentants'],
  },
];

const ROUTE_BY_ID = Object.fromEntries(
  AI_PANEL_ROUTES.map((route) => [route.routeId, route])
);

export const getAiPanelRoute = (routeId: string): AiPanelRoute | undefined =>
  ROUTE_BY_ID[routeId];
